// extracted by mini-css-extract-plugin
module.exports = {"delete-metrics":"DeleteMetricsConfirmation-module__delete-metrics__1zFdW","delete-metrics-label":"DeleteMetricsConfirmation-module__delete-metrics-label__DToc0"};